import { useEffect, useLayoutEffect } from "react";
import useAuth from "./useAuth";
import { axiosPrivate } from "../api/axios";
import { useNavigate } from "react-router-dom";
import useRefreshToken from "./useRefreshToken";

const useAxiosPrivate = () => {
  const navigate = useNavigate();
  const refresh = useRefreshToken();
  const { auth } = useAuth();

  useLayoutEffect(() => {
    const requestIntercept = axiosPrivate.interceptors.request.use(
      (config) => {
        // console.log("is intercepted");
        // console.log(auth?.token);
        if (!config.headers["Authorization"]) {
          config.headers["Authorization"] = `Bearer ${auth?.token}`;
        }
        return config;
      },
      (error) => Promise.reject(error)
    );

    const responseIntercept = axiosPrivate.interceptors.response.use(
        (response) => {
            // console.log("received")
            // console.log("the response is");
            // console.log(response);
            return response;
        },
        async (error) => {
            const prevRequest = error?.config;
            if(error?.response?.status === 403 && !prevRequest?.sent) {
                prevRequest.sent = true;
                const newAccessToken = await refresh();
                prevRequest.headers['Authorization'] = `Bearer ${newAccessToken}`
                return axiosPrivate(prevRequest)
            }
            return Promise.reject(error)
        }
    )

    // const responseIntercept = axiosPrivate.interceptors.response.use(
    //   (response) => {
    //     console.log("received")
    //     console.log("the response is");
    //     console.log(response);
    //     return response;
    //   },
    //   (error) => {
    //     // console.log("the error is");
    //     if (error.response.status === 403) navigate("/");
    //     return Promise.reject(error);
    //   }
    // );

    return () => {
      axiosPrivate.interceptors.request.eject(requestIntercept);
      axiosPrivate.interceptors.response.eject(responseIntercept);
    };
  }, [auth, refresh]);
  return axiosPrivate;
};

export default useAxiosPrivate;
